import { useRecorder } from '~/scripts/services/recorder/recorder';
import { BaseController } from '~/utils/base-controller';

/**
 * @implements {angular.IController}
 */
export default class recorderUiController extends BaseController {
	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	/**
	 * @param {Knitiv.Angular.Injector} $injector
	 */
	constructor($injector) {
		super($injector);

		this.recorder = useRecorder();
	}

	$onInit() {
		//
	}
}
